import React from "react";
import Hero from "../components/Hero";
import Content from "../components/Content";

const Home = () => {
  return (
    <>
      <Hero />
      <Content />
    </>
  );
};

export default Home;
